import { graphql } from "react-relay";
import { readInlineData } from "relay-runtime";

import { newsletterCategory as newsletterCategoryData } from "shared/data/newsletter";
import { notEmpty } from "shared/lib/utils";

import type { helpersNewsletterSlideshowItemGetSizeNewsletter$key } from "scmp-app/queries/__generated__/helpersNewsletterSlideshowItemGetSizeNewsletter.graphql";

export const getSize = (reference: helpersNewsletterSlideshowItemGetSizeNewsletter$key) => {
  const data = readInlineData(
    graphql`
      fragment helpersNewsletterSlideshowItemGetSizeNewsletter on Newsletter @inline {
        newsletterCategories {
          entityId
        }
        shortDescription {
          text
        }
      }
    `,
    reference,
  );

  if (
    notEmpty(data.shortDescription?.text) ||
    data.newsletterCategories?.some(
      category =>
        category?.entityId === newsletterCategoryData.essential.entityId ||
        category?.entityId === newsletterCategoryData.subscriberOnly.entityId,
    )
  )
    return "large";

  return "default";
};
